"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _setupControl = _interopRequireDefault(require("./setupControl"));

var initControls = function initFormGroupControls(formData) {
  var controls = [];

  for (var i = 0; i < formData.length; i += 1) {
    var fieldData = formData[i];
    var control = (0, _setupControl["default"])(fieldData);
    controls.push(control);
  }

  return controls;
};

var _default = initControls;
exports["default"] = _default;